export const REGISTRATIONS_LIST_RESET = 'REGISTRATIONS_LIST_RESET';

export const REGISTRATIONS_LIST_FETCH_START = 'REGISTRATIONS_LIST_FETCH_START';
export const REGISTRATIONS_LIST_FETCH_SUCCESS = 'REGISTRATIONS_LIST_FETCH_SUCCESS';
export const REGISTRATIONS_LIST_FETCH_FAILURE = 'REGISTRATIONS_LIST_FETCH_FAILURE';
